import { Divider, VStack } from "@chakra-ui/react"

import Event from "./Event"

type EventType = 'presential' | 'tele'

interface EventInt {
    id: string,
    patient: string,
    medic: string,
    event_type: EventType
    scheduled_to: Date
}

const events: EventInt[] = [
    {
        id: '1',
        scheduled_to: new Date(),
        patient: 'Klebinho',
        medic: 'kekwomegalul',
        event_type: "presential"
    },
    {
        id: '2',
        scheduled_to: new Date(),
        patient: 'Klebinho',
        medic: 'kekwomegalul',
        event_type: "tele"
    },
    {
        id: '3',
        scheduled_to: new Date(),
        patient: 'Klebinho',
        medic: 'kekwomegalul',
        event_type: "presential"
    },
]

const NextEvents = () => {
    return (
        <VStack spacing={4} w="full" divider={<Divider w="full" />}>
            {
                events.map(ev => <Event key={ev.id} event={ev} />)
            }
        </VStack>
    )
}

export default NextEvents